/* Test «Descubre tu rutina ideal»: preguntas con botones → rutina con productos elegidos por etiquetas → agregar todo al carrito */
(function () {
  var PREGUNTAS = [
    { k: 'piel', q: '¿Cómo es tu piel?', o: [
      ['seca', 'Seca', 'Se siente tirante o se descama'], ['grasa', 'Grasa', 'Brilla en todo el rostro'],
      ['mixta', 'Mixta', 'Grasa en la zona T, normal o seca en mejillas'], ['sensible', 'Sensible', 'Se enrojece o irrita con facilidad'],
      ['normal', 'Normal', 'Equilibrada, sin grandes molestias'] ] },
    { k: 'meta', q: '¿Qué te gustaría mejorar?', o: [
      ['hidratar', 'Hidratación y luminosidad', 'Piel opaca o deshidratada'], ['calmar', 'Rojeces o irritación', 'Piel que necesita calma'],
      ['granitos', 'Granitos y poros', 'Imperfecciones y poros visibles'], ['firmeza', 'Líneas finas y firmeza', 'Primeros signos de la edad'] ] },
    { k: 'maquillaje', q: '¿Usas maquillaje o protector solar a diario?', o: [
      ['si', 'Sí, casi todos los días', 'Necesitas una limpieza más profunda'], ['no', 'No o muy poco', 'Una limpieza suave es suficiente'] ] },
    { k: 'rutina', q: '¿Qué tan completa quieres tu rutina?', o: [
      ['basica', 'Básica', 'Limpiar, hidratar y proteger'], ['completa', 'Completa', 'Con tratamiento y mascarilla'] ] }
  ];
  var PESOS = {
    piel: { seca: ['Piel seca', 'Hidratación'], grasa: ['Piel grasa', 'Poros', 'Piel con acné'], mixta: ['Poros', 'Hidratación', 'Piel grasa'], sensible: ['Piel sensible', 'Calmante', 'Centella'], normal: ['Hidratación'] },
    meta: { hidratar: ['Hidratación', 'Ácido hialurónico'], calmar: ['Piel sensible', 'Calmante', 'Centella'], granitos: ['Piel con acné', 'Poros'], firmeza: ['Antiedad', 'Firmeza'] },
    maquillaje: { si: ['Doble limpieza'], no: [] },
    // La respuesta sobre maquillaje decide el limpiador: doble limpieza si se maquilla, limpiador suave si no
    pesoMaquillaje: { si: 4, no: -2 }
  };
  var PASOS = [
    { tag: 'Limpiadores', nombre: 'Limpia', cuando: 'Mañana y noche' },
    { tag: 'Sérums', nombre: 'Trata', cuando: 'Noche', solo: 'completa' },
    { tag: 'Cremas hidratantes', nombre: 'Hidrata', cuando: 'Mañana y noche' },
    { tag: 'Protectores solares', nombre: 'Protege', cuando: 'Cada mañana' },
    { tag: 'Mascarillas', nombre: 'Extra: mascarilla', cuando: '2 o 3 veces por semana', solo: 'completa' }
  ];
  var TXT = { seca: 'seca', grasa: 'grasa', mixta: 'mixta', sensible: 'sensible', normal: 'normal', hidratar: 'hidratación y luminosidad', calmar: 'calmar rojeces e irritación', granitos: 'granitos y poros', firmeza: 'líneas finas y firmeza' };

  function init(root) {
    var prods = [];
    try { prods = JSON.parse(root.querySelector('[data-quiz-products]').textContent); } catch (e) { return; }
    var r = {}, i = 0;
    var $ = function (s) { return root.querySelector(s); };
    var intro = $('[data-paso="0"]'), box = $('[data-quiz-box]'), res = $('[data-quiz-res]');

    function pinta() {
      var P = PREGUNTAS[i];
      $('[data-quiz-bar]').style.width = ((i + 1) / PREGUNTAS.length * 100) + '%';
      $('[data-quiz-count]').textContent = (i + 1) + ' de ' + PREGUNTAS.length;
      $('[data-quiz-back]').style.visibility = i ? 'visible' : 'hidden';
      var h = '<h3 class="bb-quiz__title">' + P.q + '</h3><div class="bb-quiz__opts">';
      P.o.forEach(function (o) { h += '<button type="button" class="bb-quiz__opt' + (r[P.k] === o[0] ? ' is-on' : '') + '" data-v="' + o[0] + '"><b>' + o[1] + '</b><span>' + o[2] + '</span></button>'; });
      $('[data-quiz-q]').innerHTML = h + '</div>';
    }
    function puntaje(p) {
      var s = 0;
      ['piel', 'meta'].forEach(function (k) { (PESOS[k][r[k]] || []).forEach(function (t) { if (p.tags.indexOf(t) > -1) s += (k === 'meta' ? 2 : 1); }); });
      if (p.tags.indexOf('Doble limpieza') > -1) s += PESOS.pesoMaquillaje[r.maquillaje] || 0;
      return s;
    }
    function rutina() {
      var out = [];
      PASOS.forEach(function (paso) {
        if (paso.solo && r.rutina !== paso.solo) return;
        // El retinal no es el primer paso para piel sensible, salvo que busque firmeza
        if (paso.tag === 'Sérums' && r.piel === 'sensible' && r.meta !== 'firmeza') return;
        var cand = prods.filter(function (p) { return p.tags.indexOf(paso.tag) > -1; });
        if (!cand.length) return;
        cand.sort(function (a, b) { return puntaje(b) - puntaje(a); });
        out.push({ paso: paso, p: cand[0] });
      });
      return out;
    }
    function fmt(c) { return '$' + Math.round(c / 100).toLocaleString('es-CO') + ' COP'; }
    // Total y botón según los productos que siguen marcados (la clienta puede quitar los que no quiera)
    function totales() {
      var R = root._rutina || [], total = 0, n = 0, umbral = Number(root.getAttribute('data-umbral')) || 0;
      R.forEach(function (x, k) { if (root._sel[k]) { total += x.p.p; n++; } });
      $('[data-quiz-total]').textContent = fmt(total);
      $('[data-quiz-envio]').textContent = !umbral || !n ? '' : (total >= umbral ? '¡Con esta rutina tienes envío gratis!' : 'Te faltan ' + fmt(umbral - total) + ' para el envío gratis');
      var add = $('[data-quiz-add]');
      add.textContent = n === R.length ? add.getAttribute('data-todo') : add.getAttribute('data-parcial');
      add.disabled = !n;
    }
    function resultado() {
      var R = rutina(), h = '';
      R.forEach(function (x, n) {
        h += '<li class="bb-quiz__step"><span class="bb-quiz__n">' + (n + 1) + '</span>' +
          '<a class="bb-quiz__img" href="' + x.p.u + '"><img src="' + x.p.img + '" alt="" loading="lazy" width="120" height="120"></a>' +
          '<div class="bb-quiz__info"><p class="bb-quiz__paso">' + x.paso.nombre + ' · <span>' + x.paso.cuando + '</span></p>' +
          '<a class="bb-quiz__name" href="' + x.p.u + '">' + x.p.t + '</a><p class="bb-quiz__price">' + x.p.pf + '</p></div>' +
          '<button type="button" class="bb-quiz__pick" data-quiz-pick="' + n + '" aria-pressed="true" aria-label="Incluir ' + x.p.t.replace(/"/g, '&quot;') + ' en mi compra"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7"/></svg></button></li>';
      });
      $('[data-quiz-steps]').innerHTML = h;
      $('[data-quiz-resumen]').textContent = 'Para piel ' + TXT[r.piel] + ', enfocada en ' + TXT[r.meta] + '. Úsala en este orden:';
      root._rutina = R; root._sel = R.map(function () { return true; });
      totales();
      box.hidden = true; res.hidden = false;
      res.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function empezar() { res.hidden = true; intro.hidden = true; box.hidden = false; i = 0; r = {}; pinta(); }

    $('[data-quiz-start]').addEventListener('click', empezar);
    $('[data-quiz-restart]').addEventListener('click', empezar);
    $('[data-quiz-back]').addEventListener('click', function () { if (i) { i--; pinta(); } });
    $('[data-quiz-q]').addEventListener('click', function (e) {
      var b = e.target.closest('.bb-quiz__opt'); if (!b) return;
      r[PREGUNTAS[i].k] = b.getAttribute('data-v');
      b.classList.add('is-on');
      setTimeout(function () { if (i < PREGUNTAS.length - 1) { i++; pinta(); } else resultado(); }, 220);
    });
    $('[data-quiz-steps]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-quiz-pick]'); if (!b) return;
      var k = Number(b.getAttribute('data-quiz-pick')), on = !root._sel[k];
      root._sel[k] = on; b.setAttribute('aria-pressed', String(on));
      b.closest('.bb-quiz__step').classList.toggle('is-off', !on);
      totales();
    });
    $('[data-quiz-add]').addEventListener('click', function () {
      var btn = this; var elegidos = (root._rutina || []).filter(function (x, k) { return root._sel[k]; });
      if (btn.classList.contains('is-loading') || !elegidos.length) return;
      btn.classList.add('is-loading');
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (x) { return x.id; }) : ['cart-icon-bubble'];
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: elegidos.map(function (x) { return { id: x.p.id, quantity: 1 }; }), sections: sections, sections_url: window.location.pathname }) })
        .then(function (x) { return x.json(); })
        .then(function (data) {
          btn.classList.remove('is-loading');
          if (data.status && data.description) { window.location.href = '/cart'; return; }
          if (drawer && drawer.renderContents) { data.id = data.items && data.items[0] ? data.items[0].id : undefined; drawer.classList.remove('is-empty'); drawer.renderContents(data); }
          else window.location.href = '/cart';
        })
        .catch(function () { window.location.href = '/cart'; });
    });
  }
  function boot() { document.querySelectorAll('[data-bb-quiz]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
